export const dict: Record<string, string> = {
  "ui.sessionReview.title": "Session changes",
  "ui.sessionReview.title.git": "Git changes",
  "ui.sessionReview.title.branch": "Branch changes",
  "ui.sessionReview.title.lastTurn": "Last turn changes",
  "ui.sessionReview.diffStyle.unified": "Unified",
  "ui.sessionReview.diffStyle.split": "Split",
  "ui.sessionReview.expandAll": "Expand all",
  "ui.sessionReview.collapseAll": "Collapse all",
  "ui.sessionReview.change.added": "Added",
  "ui.sessionReview.change.removed": "Removed",
  "ui.sessionReview.change.modified": "Modified",
  "ui.sessionReview.image.loading": "Loading...",
  "ui.sessionReview.image.placeholder": "Image",
  "ui.sessionReview.largeDiff.title": "Diff too large to render",
  "ui.sessionReview.largeDiff.meta": "Limit: {{limit}} changed lines. Current: {{current}} changed lines.",
  "ui.sessionReview.largeDiff.renderAnyway": "Render anyway",
  "ui.sessionReviewV2.expandMode": "Expand or collapse diff",
  "ui.sessionReviewV2.filterFiles": "Filter files",
  "ui.sessionReviewV2.toggleSidebar": "Toggle file tree",
  "ui.sessionReviewV2.showAllLines": "Show all lines",
  "ui.sessionReviewV2.hideNonDiffLines": "Hide non-diff lines",
  "ui.sessionReviewV2.unifiedDiff": "Unified diff",
  "ui.sessionReviewV2.splitDiff": "Split diff",
  "ui.sessionReviewV2.previousFile": "Previous file",
  "ui.sessionReviewV2.nextFile": "Next file",
  "ui.sessionReviewV2.diffView": "Diff view",
  "ui.sessionReviewV2.empty.noGit.title": "No tracked changes",
  "ui.sessionReviewV2.empty.noGit.description": "Track, review, and undo changes in this project",
  "ui.sessionReviewV2.empty.noGit.action": "Create Git repository",
  "ui.sessionReviewV2.empty.noGit.actionLoading": "Creating Git repository...",
  "ui.sessionReviewV2.empty.changes.title": "No file changes yet",
  "ui.sessionReviewV2.empty.changes.description": "Project changes will appear here",

  "ui.sessionReview.openFile": "Open file",
  "ui.sessionReview.selection.line": "line {{line}}",
  "ui.sessionReview.selection.lines": "lines {{start}}-{{end}}",

  "ui.fileMedia.kind.image": "image",
  "ui.fileMedia.kind.audio": "audio",
  "ui.fileMedia.state.removed": "Removed {{kind}} file.",
  "ui.fileMedia.state.loading": "Loading {{kind}}...",
  "ui.fileMedia.state.error": "Unable to load {{kind}}.",
  "ui.fileMedia.state.unavailable": "{{kind}} preview unavailable.",
  "ui.fileMedia.binary.title": "Binary file",
  "ui.fileMedia.binary.description.path": "{{path}} is binary.",
  "ui.fileMedia.binary.description.default": "Binary content",

  "ui.lineComment.label.prefix": "Comment on ",
  "ui.lineComment.label.suffix": "",
  "ui.lineComment.editorLabel.prefix": "Commenting on ",
  "ui.lineComment.editorLabel.suffix": "",
  "ui.lineComment.placeholder": "Add comment",
  "ui.lineComment.contextPlaceholder": "Add context for this change",
  "ui.lineComment.submit": "Comment",
  "ui.lineComment.cancel": "Cancel",

  "ui.sessionTurn.steps.show": "Show steps",
  "ui.sessionTurn.steps.hide": "Hide steps",
  "ui.sessionTurn.summary.response": "Response",
  "ui.sessionTurn.diff.showMore": "Show more changes ({{count}})",
  "ui.sessionTurn.diffs.changed.one": "{{count}} Changed file",
  "ui.sessionTurn.diffs.changed.other": "{{count}} Changed files",
  "ui.sessionTurn.diffs.showAll": "Show all",
  "ui.sessionTurn.diffs.showLess": "Show less",
  "ui.sessionTurn.diffs.more": "+{{count}} more files",

  "ui.sessionTurn.retry.retrying": "retrying",
  "ui.sessionTurn.retry.inSeconds": "in {{seconds}}s",
  "ui.sessionTurn.retry.attempt": "attempt #{{attempt}}",
  "ui.sessionTurn.retry.attemptLine": "{{line}} - attempt #{{attempt}}",
  "ui.sessionTurn.retry.geminiHot": "gemini is way too hot right now",
  "ui.sessionTurn.error.freeUsageExceeded": "Free usage exceeded",
  "ui.sessionTurn.error.addCredits": "Add credits",

  "dialog.usageExceeded.freeTier.title": "Free limit reached",
  "dialog.usageExceeded.freeTier.description":
    "Subscribe to OpenCode Go for reliable access to the best open-source models for $10/month.",
  "dialog.usageExceeded.freeTier.actionLabel": "Subscribe",
  "dialog.usageExceeded.accountRateLimit.title": "Go limit reached",
  "dialog.usageExceeded.accountRateLimit.description":
    "Usage limit reached. To continue using this model now, enable usage from your available balance",
  "dialog.usageExceeded.accountRateLimit.actionLabel": "Open settings",

  "ui.sessionTurn.status.delegating": "Delegating work",
  "ui.sessionTurn.status.planning": "Planning next steps",
  "ui.sessionTurn.status.gatheringContext": "Exploring",
  "ui.sessionTurn.status.gatheredContext": "Explored",
  "ui.sessionTurn.status.searchingCodebase": "Searching the codebase",
  "ui.sessionTurn.status.searchingWeb": "Searching the web",
  "ui.sessionTurn.status.makingEdits": "Making edits",
  "ui.sessionTurn.status.runningCommands": "Running commands",
  "ui.sessionTurn.status.thinking": "Thinking",
  "ui.sessionTurn.status.thinkingWithTopic": "Thinking - {{topic}}",
  "ui.sessionTurn.status.gatheringThoughts": "Gathering thoughts",
  "ui.sessionTurn.status.consideringNextSteps": "Considering next steps",

  "ui.messagePart.diagnostic.error": "Error",
  "ui.messagePart.title.edit": "Edit",
  "ui.messagePart.title.write": "Write",
  "ui.messagePart.option.typeOwnAnswer": "Type your own answer",
  "ui.messagePart.review.title": "Review your answers",
  "ui.messagePart.questions.dismissed": "Questions dismissed",
  "ui.messagePart.compaction": "Session compacted",
  "ui.messagePart.context.read.one": "{{count}} read",
  "ui.messagePart.context.read.other": "{{count}} reads",
  "ui.messagePart.context.search.one": "{{count}} search",
  "ui.messagePart.context.search.other": "{{count}} searches",
  "ui.messagePart.context.list.one": "{{count}} list",
  "ui.messagePart.context.list.other": "{{count}} lists",

  "ui.list.loading": "Loading",
  "ui.list.empty": "No results",
  "ui.list.clearFilter": "Clear filter",
  "ui.list.emptyWithFilter.prefix": "No results for",
  "ui.list.emptyWithFilter.suffix": "",

  "ui.fileSearch.placeholder": "Find",
  "ui.fileSearch.previousMatch": "Previous match",
  "ui.fileSearch.nextMatch": "Next match",
  "ui.fileSearch.close": "Close search",

  "ui.messageNav.newMessage": "New message",

  "ui.promptInput.noMatchingItems": "No matching items",
  "ui.promptInput.commands": "Commands",
  "ui.promptInput.dropFiles": "Drop files to attach",
  "ui.promptInput.removeAttachment": "Remove attachment",
  "ui.promptInput.label": "Prompt",
  "ui.promptInput.placeholder.shell": "Enter shell command...",
  "ui.promptInput.placeholder.normal": "Ask anything, {{slash}} for commands, {{at}} for context...",
  "ui.promptInput.add": "Add images and files",
  "ui.promptInput.attachments": "Images and files",
  "ui.promptInput.context": "Context",
  "ui.promptInput.shell": "Shell command",
  "ui.promptInput.chooseAgent": "Choose agent",
  "ui.promptInput.chooseModel": "Choose model",
  "ui.promptInput.chooseVariant": "Choose model variant",
  "ui.promptInput.send": "Send",
  "ui.promptInput.stop": "Stop",

  "ui.tabs.close": "Close tab",

  "ui.textField.copyToClipboard": "Copy to clipboard",
  "ui.textField.copyLink": "Copy link",
  "ui.textField.copied": "Copied",

  "ui.imagePreview.alt": "Image preview",
  "ui.scrollView.ariaLabel": "scrollable content",

  "ui.tool.read": "Read",
  "ui.tool.loaded": "Loaded",
  "ui.tool.list": "List",
  "ui.tool.glob": "Glob",
  "ui.tool.grep": "Grep",
  "ui.tool.task": "Task",
  "ui.tool.webfetch": "Webfetch",
  "ui.tool.websearch": "Web Search",
  "ui.tool.websearch.provider": "{{provider}} Web Search",
  "ui.tool.shell": "Shell",
  "ui.tool.patch": "Patch",
  "ui.tool.todos": "To-dos",
  "ui.tool.todos.read": "Read to-dos",
  "ui.tool.questions": "Questions",
  "ui.tool.questions.numbered": "Questions {{number}}",
  "ui.tool.agent": "{{type}} Agent",
  "ui.tool.agent.default": "Agent",
  "ui.tool.skill": "Skill",

  "ui.basicTool.called": "Called `{{tool}}`",
  "ui.toolErrorCard.failed": "Failed",
  "ui.toolErrorCard.copyError": "Copy error",

  "ui.common.file.one": "file",
  "ui.common.file.other": "files",
  "ui.common.question.one": "question",
  "ui.common.question.other": "questions",

  "ui.common.add": "Add",
  "ui.common.clear": "Clear",
  "ui.common.file": "File",
  "ui.common.back": "Back",
  "ui.common.cancel": "Cancel",
  "ui.common.confirm": "Confirm",
  "ui.common.dismiss": "Dismiss",
  "ui.common.close": "Close",
  "ui.common.next": "Next",
  "ui.common.submit": "Submit",
  "ui.common.showMore": "Show more",

  "ui.permission.deny": "Deny",
  "ui.permission.allowAlways": "Allow always",
  "ui.permission.allowOnce": "Allow once",

  "ui.message.expand": "Expand message",
  "ui.message.collapse": "Collapse message",
  "ui.message.copy": "Copy",
  "ui.message.copyMessage": "Copy message",
  "ui.message.forkMessage": "Fork to new session",
  "ui.message.revertMessage": "Revert message",
  "ui.message.copyResponse": "Copy response",
  "ui.message.copied": "Copied",
  "ui.message.duration.seconds": "{{count}}s",
  "ui.message.duration.minutesSeconds": "{{minutes}}m {{seconds}}s",
  "ui.message.interrupted": "Interrupted",
  "ui.message.queued": "Queued",
  "ui.message.attachment.alt": "attachment",

  "ui.patch.action.deleted": "Deleted",
  "ui.patch.action.created": "Created",
  "ui.patch.action.moved": "Moved",
  "ui.patch.action.patched": "Patched",

  "ui.question.subtitle.answered": "{{count}} answered",
  "ui.question.answer.none": "(no answer)",
  "ui.question.review.notAnswered": "(not answered)",
  "ui.question.multiHint": "Select all answers that apply",
  "ui.question.singleHint": "Select one answer",
  "ui.question.custom.placeholder": "Type your answer...",
}
